import { AppType } from '@watershed/config/constants';
import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';
import { BadInputError } from '@watershed/errors/BadInputError';

function ensureSlug(value: string, label: string): string {
  BadInputError.invariant(value, `Docs ${label} slug must be provided`);
  BadInputError.invariant(
    !value.includes('/'),
    `Docs ${label} slug must be a single path segment`
  );
  return value;
}

export const DOCS_ROUTE_PREFIX = '/docs';

// app-docs uses Next.js basePath, so internal URLs use no prefix
// but in Dashboard, we need to prefix the routes with /docs
export const routeForCurrentDocsPrefix = (): string => {
  const app = getPublicRuntimeConfig('NEXT_PUBLIC_APPLICATION');
  if (app === AppType.Dashboard) {
    return DOCS_ROUTE_PREFIX;
  } else {
    return '';
  }
};

export const routeForDocs = (): string => {
  return routeForCurrentDocsPrefix() === '' ? '/' : routeForCurrentDocsPrefix();
};

export const routeForDocsGlossary = (): string =>
  `${routeForCurrentDocsPrefix()}/glossary`;

export const routeForDocsGlossaryTerm = (termSlug: string): string => {
  return `${routeForDocsGlossary()}/${ensureSlug(termSlug, 'glossary term')}`;
};

export const routeForDocsCategory = (categorySlug: string): string => {
  return `${routeForCurrentDocsPrefix()}/category/${ensureSlug(categorySlug, 'category')}`;
};

export const routeForDocsPage = (pageSlug: string): string => {
  return `${routeForCurrentDocsPrefix()}/${ensureSlug(pageSlug, 'page')}`;
};

export const routeForDocsSearch = (query: string): string => {
  const suffix = query ? '/' + encodeURIComponent(query) : '';
  return `${routeForCurrentDocsPrefix()}/search${suffix}`;
};
